<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-3xl mx-4 sm:mx-6">
  @if (ticket) {
  <div class="p-6 sm:p-8">

    <!-- Barra de acciones (INC 43) -->
    <div class="flex items-center gap-1.5 flex-wrap justify-end mb-4 pb-4 border-b border-gray-200 dark:border-gray-700">
      @if (canReopen()) {
        <button type="button" (click)="abrirAccion('reopen')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-yellow-100 text-yellow-700 hover:bg-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-400 dark:hover:bg-yellow-900/50">
          Reabrir
        </button>
      }

      <button type="button" (click)="abrirAccion('escalate')"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-orange-100 text-orange-700 hover:bg-orange-200 dark:bg-orange-900/30 dark:text-orange-400 dark:hover:bg-orange-900/50">
        Escalar
      </button>

      @if (canResolve()) {
        <button type="button" (click)="abrirAccion('resolve')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-green-600 text-white hover:bg-green-700">
          Resolver
        </button>
      }

      <!-- Menú desplegable de acciones de jerarquía/vínculos.
           Inc 73: oculto cuando el ticket es un subticket. -->
      @if (!esSubTicket) {
      <div class="relative inline-block" (click)="$event.stopPropagation()">
        <button type="button" (click)="toggleLinksMenu()"
          [attr.aria-expanded]="linksMenuOpen"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 inline-flex items-center gap-1.5">
          Vínculos
          <svg class="w-3 h-3 transition-transform" [class.rotate-180]="linksMenuOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
          </svg>
        </button>

        @if (linksMenuOpen) {
          <div class="absolute right-0 mt-2 w-52 z-dropdown overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg dark:border-gray-700 dark:bg-gray-900">
            <ul class="py-1">
              <li>
                <button type="button" (click)="abrirAccion('sub-ticket')"
                  class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                  Crear sub-ticket
                </button>
              </li>
              <li>
                <button type="button" (click)="abrirAccion('merge')"
                  class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                  Fusionar tickets
                </button>
              </li>
              <li>
                <button type="button" (click)="abrirAccion('split')"
                  class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-gray-800">
                  Dividir ticket
                </button>
              </li>
            </ul>
          </div>
        }
      </div>
      }
    </div>

    <app-tickets-detail-tabs
      [ticket]="ticket"
      [priorities]="priorities"
      [statuses]="statuses"
      [categories]="categories"
      [pipelines]="pipelines"
      [stages]="stages"
      [showHeader]="true"
      (quickAction)="onClose()"
      (subTicketCreated)="onSubTicketCreated($event)">
    </app-tickets-detail-tabs>
  </div>
  }
</app-modal>

<!-- Modal multi-acción (por encima del modal de detalle) -->
<app-tickets-actions-modals
  [ticket]="ticket"
  [action]="activeAction"
  [statuses]="statuses"
  [priorities]="priorities"
  [categories]="categories"
  [rootCauses]="rootCauses"
  (closed)="cerrarAccion()"
  (saved)="onAccionCompletada($event)">
</app-tickets-actions-modals>
